/* ============================================================
   Beneos Battlemaps : homepage interactions.
   Operates on server-rendered markup. Every block is guarded by
   element presence, so this file is safe to load once on the page.
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // Uebersetzte Beschriftung. Die Bruecke liegt in snippets/beneos-i18n.liquid
  // und wird dort gerendert, wo diese Datei geladen wird. Faellt sie aus,
  // bleibt der englische Rueckfallwert stehen, nie eine leere Flaeche.
  function T(k, d) {
    var s = (window.Beneos && window.Beneos.strings) || {};
    var v = (s[k] != null && s[k] !== '') ? s[k] : d;
    // Shopify maskiert Uebersetzungswerte zu HTML-Entitaeten, ausser der
    // Schluessel endet auf _html. Hier wird wieder Rohtext daraus.
    return String(v).replace(/&(amp|lt|gt|quot|#39);/g, function (m, e) {
      return { 'amp': '&', 'lt': '<', 'gt': '>', 'quot': '"', '#39': "'" }[e];
    });
  }

  /* ready-to-run: scene tabs + per-scene hotspots (re-initialisable for the theme editor) */
  (function () {
    function initReady(section) {
      if (!section || section.getAttribute('data-ready-init') === '1') return;
      section.setAttribute('data-ready-init', '1');

      /* hotspot toggle, scoped per scene stage (one open at a time within its scene) */
      $$('.ready-stage', section).forEach(function (stage) {
        $$('.hotspot', stage).forEach(function (hs) {
          var btn = $('.hs-btn', hs);
          if (!btn) return;
          btn.addEventListener('click', function () {
            var isOpen = hs.classList.contains('on');
            $$('.hotspot', stage).forEach(function (x) {
              x.classList.remove('on');
              var c = $('.hs-callout', x); if (c) c.classList.add('is-hidden');
            });
            if (!isOpen) {
              hs.classList.add('on');
              var c = $('.hs-callout', hs); if (c) c.classList.remove('is-hidden');
            }
          });
        });
      });

      /* first-visit eyecatcher above the toolbar: dismiss on first interaction, remember it */
      var hint = section.querySelector('[data-ready-hint]');
      function dismissHint() {
        if (!hint) return;
        hint.classList.add('is-gone');
        try { window.localStorage.setItem('beneosReadyHintSeen2', '1'); } catch (e) {}
        var h = hint; hint = null;
        setTimeout(function () { if (h && h.parentNode) h.parentNode.removeChild(h); }, 400);
      }
      if (hint) {
        var hintSeen = false;
        try { hintSeen = !!window.localStorage.getItem('beneosReadyHintSeen2'); } catch (e) {}
        if (hintSeen) { if (hint.parentNode) hint.parentNode.removeChild(hint); hint = null; }
        else { hint.addEventListener('click', dismissHint); }
      }

      /* audio rack: stylized waveform + live analyser reaction on play, one track at a time */
      var raiStrips = $$('.rai-strip', section);
      var raiRaf = null, raiActive = null;
      function raiFmt(s) { s = Math.max(0, Math.floor(s || 0)); var m = Math.floor(s / 60), sec = s % 60; return m + ':' + (sec < 10 ? '0' : '') + sec; }
      function stopAllAudio() {
        raiStrips.forEach(function (st) { var a = $('audio', st); if (a) { try { a.pause(); } catch (e) {} } st.classList.remove('is-playing'); });
        if (raiRaf) { cancelAnimationFrame(raiRaf); raiRaf = null; }
        raiActive = null;
      }
      /* volume (default 75%), applies to all tracks in the rack */
      var volEl = section.querySelector('[data-ready-vol]');
      function applyVol() { var v = volEl ? (parseInt(volEl.value, 10) || 0) / 100 : 0.75; raiStrips.forEach(function (st) { var a = $('audio', st); if (a) a.volume = v; }); }
      if (volEl) volEl.addEventListener('input', applyVol);
      applyVol();
      raiStrips.forEach(function (st, idx) {
        var audio = $('audio', st), canvas = $('.rai-wave', st), btn = $('.rai-play', st), timeEl = $('.rai-time', st);
        if (!audio || !canvas || !btn) return;
        var g = canvas.getContext('2d'), BARS = 44;
        var src = audio.getAttribute('src') || ('' + idx), seed = 2166136261 ^ idx;
        for (var s0 = 0; s0 < src.length; s0++) { seed = (seed ^ src.charCodeAt(s0)) >>> 0; seed = (seed * 16777619) >>> 0; }
        function rnd() { seed = (seed * 1664525 + 1013904223) >>> 0; return seed / 4294967296; }
        var base = [], live; for (var b0 = 0; b0 < BARS; b0++) { base.push(0.22 + 0.74 * Math.pow(rnd(), 0.75)); }
        live = base.slice();
        var analyser = null, freq = null, zeroFrames = 0, synthetic = false, phase = rnd() * 6.283;
        function sizeCanvas() { var r = canvas.getBoundingClientRect(), dpr = window.devicePixelRatio || 1; canvas.width = Math.max(1, Math.round(r.width * dpr)); canvas.height = Math.max(1, Math.round(r.height * dpr)); }
        function draw(progress) {
          var w = canvas.width, h = canvas.height, dpr = window.devicePixelRatio || 1;
          g.clearRect(0, 0, w, h);
          var gap = Math.max(1, Math.round(2 * dpr)), bw = Math.max(1, (w - (BARS - 1) * gap) / BARS);
          for (var i = 0; i < BARS; i++) {
            var bh = Math.max(2 * dpr, live[i] * h), x = i * (bw + gap), y = (h - bh) / 2;
            g.fillStyle = (i / BARS) <= progress ? 'rgba(233,197,112,0.95)' : 'rgba(233,197,112,0.30)';
            g.fillRect(x, y, bw, bh);
          }
        }
        sizeCanvas(); draw(0);
        var rT; window.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(function () { sizeCanvas(); draw(raiActive === st && audio.duration ? audio.currentTime / audio.duration : 0); }, 150); });
        function ensureAnalyser() {
          if (analyser || synthetic) return;
          try {
            if (!window.__beneosAudioCtx) window.__beneosAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
            var ctx = window.__beneosAudioCtx;
            if (!audio._raiSrc) { audio._raiSrc = ctx.createMediaElementSource(audio); audio._raiSrc.connect(ctx.destination); }
            analyser = ctx.createAnalyser(); analyser.fftSize = 128; analyser.smoothingTimeConstant = 0.82;
            audio._raiSrc.connect(analyser); freq = new Uint8Array(analyser.frequencyBinCount);
          } catch (e) { analyser = null; synthetic = true; }
        }
        function frame() {
          if (raiActive !== st) return;
          if (analyser && freq) {
            analyser.getByteFrequencyData(freq); var sum = 0;
            for (var i = 0; i < BARS; i++) { var v = freq[Math.floor(i / BARS * freq.length)] / 255; sum += v; live[i] = Math.min(1, base[i] * (0.45 + 0.55 * v) + v * 0.25); }
            if (sum < 0.4) { if (++zeroFrames > 30) synthetic = true; } else zeroFrames = 0;
          }
          if (synthetic || !analyser) { phase += 0.18; for (var j = 0; j < BARS; j++) { live[j] = base[j] * (0.55 + 0.45 * Math.abs(Math.sin(phase + j * 0.5))); } }
          draw(audio.duration ? audio.currentTime / audio.duration : 0);
          if (timeEl) timeEl.textContent = raiFmt(audio.currentTime);
          raiRaf = requestAnimationFrame(frame);
        }
        function play() {
          stopAllAudio(); ensureAnalyser();
          if (window.__beneosAudioCtx && window.__beneosAudioCtx.state === 'suspended') { window.__beneosAudioCtx.resume(); }
          var pr = audio.play(); if (pr && pr.catch) pr.catch(function () {});
          st.classList.add('is-playing'); raiActive = st; frame();
        }
        btn.addEventListener('click', function () {
          if (st.classList.contains('is-playing')) { stopAllAudio(); live = base.slice(); draw(audio.duration ? audio.currentTime / audio.duration : 0); }
          else { play(); }
        });
        audio.addEventListener('ended', function () { if (raiRaf) { cancelAnimationFrame(raiRaf); raiRaf = null; } st.classList.remove('is-playing'); raiActive = null; live = base.slice(); draw(0); if (timeEl) timeEl.textContent = raiFmt(0); });
      });

      /* scene tabs: crossfade background, copy and hotspots together */
      var tabs = $$('.rt-tool', section);
      if (!tabs.length) return;
      function activate(id) {
        stopAllAudio();
        var activeHasAudio = false;
        /* every scene starts with all hotspots closed; they only open on click */
        $$('.hotspot', section).forEach(function (x) {
          x.classList.remove('on');
          var c = $('.hs-callout', x); if (c) c.classList.add('is-hidden');
        });
        tabs.forEach(function (t) { t.classList.toggle('on', t.getAttribute('data-scene') === id); });
        $$('[data-scene-panel]', section).forEach(function (p) {
          var on = p.getAttribute('data-scene-panel') === id;
          p.classList.toggle('is-active', on);
          if (on && p.classList.contains('ready-copy-panel') && p.classList.contains('has-audio')) activeHasAudio = true;
          var vid = $('video', p);
          if (vid) { if (on) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); } else { vid.pause(); } }
        });
        section.classList.toggle('has-audio-active', activeHasAudio);
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { activate(t.getAttribute('data-scene')); dismissHint(); });
      });
      /* kick off autoplay for the active scene video, pause the rest */
      $$('.ready-bg', section).forEach(function (bg) {
        var v = $('video', bg);
        if (!v) return;
        if (bg.classList.contains('is-active')) { var rp = v.play(); if (rp && rp.catch) rp.catch(function () {}); }
        else { try { v.pause(); } catch (e) {} }
      });
      section.activateReadyBlock = function (blockId) {
        var t = tabs.filter(function (x) { return x.getAttribute('data-block-id') === blockId; })[0];
        if (t) activate(t.getAttribute('data-scene'));
      };
    }

    $$('.ready').forEach(initReady);

    /* Shopify theme editor: re-init on section reload, and show the selected scene so its hotspots are editable */
    document.addEventListener('shopify:section:load', function (e) {
      var t = e.target;
      var s = t && t.matches && t.matches('.ready') ? t : (t && t.querySelector ? t.querySelector('.ready') : null);
      if (s) initReady(s);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var s = e.target && e.target.closest ? e.target.closest('.ready') : null;
      if (s && s.activateReadyBlock && e.detail && e.detail.blockId) s.activateReadyBlock(e.detail.blockId);
    });
  })();

  /* choose setup */
  (function () {
    var cards = $$('.setup-card');
    if (!cards.length) return;
    function pick(id) {
      cards.forEach(function (c) { c.classList.toggle('on', c.getAttribute('data-setup') === id); });
      $$('.setup-detail').forEach(function (d) { d.classList.toggle('is-hidden', d.getAttribute('data-setup') !== id); });
    }
    cards.forEach(function (c) {
      c.addEventListener('click', function () { pick(c.getAttribute('data-setup')); });
    });
  })();

  /* before / after slider */
  (function () {
    var stage = $('#baStage'), before = $('#baBefore'), handle = $('#baHandle');
    if (!stage || !before || !handle) return;
    var dragging = false;
    function setPos(x) {
      var r = stage.getBoundingClientRect();
      var p = ((x - r.left) / r.width) * 100;
      p = Math.max(2, Math.min(98, p));
      before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
      handle.style.left = p + '%';
    }
    var start = function (e) { dragging = true; setPos(e.touches ? e.touches[0].clientX : e.clientX); };
    var move = function (e) { if (dragging) setPos(e.touches ? e.touches[0].clientX : e.clientX); };
    var end = function () { dragging = false; };
    stage.addEventListener('mousedown', start);
    stage.addEventListener('touchstart', start, { passive: true });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', end);
    window.addEventListener('touchend', end);
    var baVid = $('.ba-after video', stage);
    if (baVid) { var bp = baVid.play(); if (bp && bp.catch) bp.catch(function () {}); }
  })();

  /* usp bullet slider: each row auto-advances its per-bullet images and highlights the
     matching bullet; bullets are clickable, hover pauses, only advances while in view */
  (function () {
    var rows = $$('[data-uspslider]');
    if (!rows.length) return;
    var DELAY = 4000;
    rows.forEach(function (row) {
      var slides = $$('.usp-slide', row), bullets = $$('.usp-bullet', row);
      var n = Math.min(slides.length, bullets.length);
      if (n < 1) return;
      var cur = 0, timer = null, visible = false, hovered = false;
      function show(i) {
        cur = (i % n + n) % n;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
        bullets.forEach(function (b, k) { b.classList.toggle('is-active', k === cur); });
      }
      function tick() { if (visible && !hovered && n > 1 && !timer) timer = setInterval(function () { show(cur + 1); }, DELAY); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      bullets.forEach(function (b, k) {
        var btn = $('.usp-bullet-btn', b) || b;
        btn.addEventListener('click', function () { show(k); stop(); tick(); });
      });
      row.addEventListener('mouseenter', function () { hovered = true; stop(); });
      row.addEventListener('mouseleave', function () { hovered = false; tick(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { visible = e.isIntersecting; if (visible) tick(); else stop(); });
        }, { threshold: 0.25 }).observe(row);
      } else { visible = true; tick(); }
      show(0);
    });
  })();

  /* live library search: browse the public Beneos DB on the homepage; downloads open a sign-in prompt */
  (function () {
    var root = $('[data-live-search]');
    if (!root || !window.BeneosDB) return;

    var KINDS = {
      token:     { thumbField: 'thumbnail', aspect: null,   placeholder: T('home.search_creatures', 'Search creatures…') },
      battlemap: { thumbField: 'thumbnail', aspect: 'wide', placeholder: T('home.search_battlemaps', 'Search battlemaps…') },
      spell:     { thumbField: 'icon',      aspect: null,   placeholder: T('home.search_spells', 'Search spells…') },
      item:      { thumbField: 'icon',      aspect: null,   placeholder: T('home.search_loot', 'Search loot…') }
    };
    /* per-type facet dropdowns (key = DB property, arr = value is an array). Built live from the data. */
    var FACETS = {
      token: [
        { key: 'biom', label: T('home.f_biome', 'Biome'), arr: true },
        { key: 'fightingstyle', label: T('home.f_fighting_style', 'Fighting style'), arr: true },
        { key: 'purpose', label: T('home.f_purpose', 'Purpose'), arr: true }
      ],
      battlemap: [
        { key: 'biom', label: T('home.f_biome', 'Biome'), arr: true },
        { key: 'adventure', label: T('home.f_adventure', 'Adventure'), arr: true },
        { key: 'type', label: T('home.f_type', 'Type') },
        { key: 'brightness', label: T('home.f_brightness', 'Brightness') },
        { key: 'grid', label: T('home.f_grid', 'Grid') }
      ],
      spell: [
        { key: 'level', label: T('home.f_level', 'Level') },
        { key: 'school', label: T('home.f_school', 'School') },
        { key: 'spell_type', label: T('home.f_type', 'Type') }
      ],
      item: [
        { key: 'origin', label: T('home.f_origin', 'Origin') },
        { key: 'item_type', label: T('home.f_item_type', 'Item type') }
      ]
    };
    var PAGE = 24;
    var DL_ICON = '<svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2v8m0 0l3-3m-3 3l-3-3M3 13h10"/></svg>';
    var LOCK_ICON = '<svg width="9" height="9" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="7" width="9" height="6" rx="1"/><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2"/></svg>';

    var resultsEl = $('[data-ls-results]', root), countEl = $('[data-ls-count]', root);
    var emptyEl = $('[data-ls-empty]', root), moreWrap = $('[data-ls-more]', root), moreBtn = $('[data-ls-loadmore]', root);
    var searchEl = $('[data-ls-search]', root), sortEl = $('[data-ls-sort]', root);
    var tagsWrap = $('[data-ls-tags]', root), tagsGroup = $('[data-ls-tagsgroup]', root), tagReset = $('[data-ls-tagreset]', root);
    var facetsWrap = $('[data-ls-facets]', root);
    var tabs = $$('.exp-tab', root);

    var cache = {};
    var state = { kind: 'token', q: '', sort: 'new', tags: [], facets: {}, access: 'all', visible: PAGE };

    /* Published-gate, same allowlist the Library Explorer uses: the public catalog
       also carries unreleased future entries (icons often not on the CDN yet).
       The app-proxy serves data.published to anonymous visitors too, so every
       RELEASED asset stays publicly searchable with its thumbnail (marketing)
       while unreleased ones stay hidden. If the fetch fails, the gate stays off
       so the search never goes blank. credentials:'omit' on purpose: without the
       customer cookie the proxy always takes the cheap cached anonymous branch
       instead of building the full per-user library payload on every visit. */
    function normKey(k) { return String(k == null ? '' : k).toLowerCase().replace(/-/g, '_'); }
    var publishedPromise = fetch('/apps/beneos/library', { headers: { 'Accept': 'application/json' }, credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var d = (j && j.data) || {};
        var sets = null;
        if (d.published) {
          sets = {};
          ['token', 'item', 'spell'].forEach(function (k) {
            var map = {};
            (Array.isArray(d.published[k]) ? d.published[k] : []).forEach(function (fn) { map[normKey(fn)] = true; });
            sets[k] = map;
          });
        }
        /* Battlemaps run the other way round: the catalog holds several thousand
           entries, so an allowlist would be a multiple of the payload on every
           visit. The server sends a deny-list of the scenes that belong to a
           release which is not published yet. Missing field = nothing to hide. */
        var hidden = {};
        var un = d.unpublished && d.unpublished.battlemap;
        (Array.isArray(un) ? un : []).forEach(function (k) { hidden[normKey(k)] = true; });
        return { sets: sets, hidden: hidden };
      })
      .catch(function () { return { sets: null, hidden: {} }; });

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function fmt(n) { return Number(n).toLocaleString(document.documentElement.lang || 'en-US'); }
    function arrStr(t) { return Array.isArray(t) ? t.join(', ') : (t || ''); }
    function disp(v) { return String(v).replace(/_/g, ' ').replace(/\b([a-z])/g, function (m, c) { return c.toUpperCase(); }); }
    function crNum(v) { if (v == null || v === '') return null; var s = String(v); if (s.indexOf('/') > -1) { var q = s.split('/'); return parseFloat(q[0]) / parseFloat(q[1]) || 0; } var n = parseFloat(s); return isNaN(n) ? null : n; }
    function priceNum(v) { if (v == null) return null; var n = parseFloat(String(v).replace(/[^0-9.]/g, '')); return isNaN(n) ? null : n; }

    function subFor(kind, p) {
      if (kind === 'token') return arrStr(p.type) + (p.cr != null && p.cr !== '' ? ' · CR ' + p.cr : '');
      if (kind === 'battlemap') return (p.type || 'Battlemap');
      if (kind === 'spell') return (p.school || '') + (p.level != null && p.level !== '' ? ' · ' + T('home.lvl_abbr', 'Lvl') + ' ' + p.level : '');
      if (kind === 'item') return (p.item_type || p.rarity || '');
      return '';
    }
    function normalize(kind, content) {
      var thumbField = KINDS[kind].thumbField, out = [];
      Object.keys(content).forEach(function (key) {
        var e = content[key]; if (!e) return;
        var p = e.properties || {};
        var f = p[thumbField] || p.thumbnail || p.icon;
        var tags = Array.isArray(p.hidden_tags) ? p.hidden_tags
          : (p.hidden_tags ? String(p.hidden_tags).split(',').map(function (s) { return s.trim(); }).filter(Boolean) : []);
        var sub = subFor(kind, p);
        var rawDesc = e.description || p.shortdesc || p.description || '';
        out.push({
          key: key, name: e.name || key,
          props: p,
          thumb: f ? window.BeneosDB.thumbUrl(kind, f) : null,
          desc: String(rawDesc).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim(),
          sub: sub,
          cr: kind === 'token' ? crNum(p.cr) : (kind === 'item' ? priceNum(p.price) : null),
          crLabel: (kind === 'token' && p.cr != null && p.cr !== '') ? ('CR ' + p.cr) : null,
          rel: (parseInt(window.BeneosDB.releaseOf(key, p.pack), 10) || 0),
          // Das Erscheinungsdatum aus dem Katalog. Alle vier Kataloge fuehren es auf jedem
          // Eintrag; die Release-Nummer daneben ist bei Kreaturen, Beute und Zaubern nur
          // die Zahl am Anfang des Schluessels und sagt ueber Frische nichts.
          date: String(p.release_date || ''),
          free: p.free_content === true,
          // Battlemap hidden_tags are search-only synonyms from the catalog
          // admin: they must never render as card chips or top-tag buttons,
          // but they stay part of the search haystack below.
          tags: kind === 'battlemap' ? [] : tags,
          search: ((e.name || '') + ' ' + tags.join(' ') + ' ' + sub).toLowerCase()
        });
      });
      return out;
    }
    function topTags(items) {
      var freq = {};
      items.forEach(function (it) { it.tags.forEach(function (t) { if (t) freq[t] = (freq[t] || 0) + 1; }); });
      return Object.keys(freq).sort(function (a, b) { return freq[b] - freq[a]; }).slice(0, 10);
    }
    function filtered() {
      var items = cache[state.kind] || [], q = state.q.trim().toLowerCase();
      var fk = Object.keys(state.facets).filter(function (k) { return state.facets[k]; });
      var res = items.filter(function (it) {
        if (state.access === 'free' && !it.free) return false;
        if (q && it.search.indexOf(q) === -1) return false;
        if (state.tags.length && !state.tags.every(function (t) { return it.tags.indexOf(t) !== -1; })) return false;
        if (fk.length && !fk.every(function (k) {
          var sel = state.facets[k], v = it.props[k];
          if (v == null) return false;
          return Array.isArray(v) ? v.map(String).indexOf(sel) !== -1 : String(v) === sel;
        })) return false;
        return true;
      });
      /* Neuestes zuerst heisst juengstes Erscheinungsdatum zuerst, in allen vier Rubriken.
         Vorher entschied die Release-Nummer, und die ist bei Kreaturen, Beute und Zaubern
         die Zahl am Anfang des Schluessels, also eine Ordnungszahl und kein Datum. Gleicher
         Tag bricht ueber die Nummer, dann ueber den Namen, damit die Reihenfolge bei jedem
         Aufruf dieselbe ist. Ohne Datum ans Ende statt an den Anfang. */
      if (state.sort === 'new') res.sort(function (a, b) {
        var c = (b.date || '').localeCompare(a.date || '');
        if (c !== 0) return c;
        if (b.rel !== a.rel) return b.rel - a.rel;
        return a.name.localeCompare(b.name);
      });
      else if (state.sort === 'name') res.sort(function (a, b) { return a.name.localeCompare(b.name); });
      else if (state.sort === 'cr') res.sort(function (a, b) { return (b.cr || 0) - (a.cr || 0); });
      return res;
    }
    function cardHtml(it) {
      var aspect = KINDS[state.kind].aspect;
      var thumb = it.thumb ? '<img src="' + esc(it.thumb) + '" alt="' + esc(it.name) + '" loading="lazy">' : '<div class="ph"></div>';
      var flags = '';
      if (it.isNew) flags += '<span class="new-tag">New</span>';
      if (it.crLabel) flags += '<span class="cr">' + esc(it.crLabel) + '</span>';
      var flagsHtml = flags ? '<div class="tl-flags">' + flags + '</div>' : '';
      var lock = it.free ? '' : '<div class="lock-tag">' + LOCK_ICON + ' Locked</div>';
      var tags = it.tags.slice(0, 3).map(function (t, i) { return '<span class="card-tag' + (i === 0 ? ' accent' : '') + '">' + esc(t) + '</span>'; }).join('');
      return '<article class="card" data-card data-key="' + esc(it.key) + '" tabindex="0">' +
        '<div class="card-thumb"' + (aspect ? ' data-aspect="' + aspect + '"' : '') + '>' + thumb + flagsHtml + lock +
          '<button class="card-dl" type="button" data-dl aria-label="View ' + esc(it.name) + '">' + DL_ICON + '</button>' +
        '</div>' +
        '<div class="card-body"><div class="card-name">' + esc(it.name) + '</div>' +
          (it.sub ? '<div class="card-sub">' + esc(it.sub) + '</div>' : '') +
          (tags ? '<div class="card-tags">' + tags + '</div>' : '') +
        '</div></article>';
    }
    function render() {
      var res = filtered();
      resultsEl.className = 'results' + (state.kind === 'battlemap' ? ' maps-view' : state.kind === 'item' ? ' items-view' : '');
      var slice = res.slice(0, state.visible);
      resultsEl.innerHTML = slice.map(cardHtml).join('');
      countEl.innerHTML = T('home.showing_html', 'Showing <b>{{ shown }}</b> of <b>{{ total }}</b>')
        .replace('{{ shown }}', fmt(slice.length)).replace('{{ total }}', fmt(res.length));
      emptyEl.hidden = res.length !== 0;
      moreWrap.hidden = res.length <= state.visible;
    }
    function buildTags() {
      var tags = topTags(cache[state.kind] || []);
      if (!tags.length) { tagsGroup.hidden = true; return; }
      tagsGroup.hidden = false;
      tagsWrap.innerHTML = tags.map(function (t) { return '<button type="button" class="fchip" data-tag="' + esc(t) + '">' + esc(t) + '</button>'; }).join('');
      if (tagReset) tagReset.hidden = true;
    }
    function buildFacets() {
      if (!facetsWrap) return;
      var cfg = FACETS[state.kind] || [], items = cache[state.kind] || [], html = '';
      cfg.forEach(function (fc) {
        var seen = {};
        items.forEach(function (it) {
          var v = it.props[fc.key]; if (v == null) return;
          (Array.isArray(v) ? v : [v]).forEach(function (x) {
            x = (x == null ? '' : String(x)).trim();
            if (x && x !== 'None') seen[x] = 1;
          });
        });
        var keys = Object.keys(seen); if (!keys.length) return;
        var allNum = keys.every(function (k) { return /^\d+(\.\d+)?$/.test(k); });
        keys.sort(allNum ? function (a, b) { return parseFloat(a) - parseFloat(b); } : function (a, b) { return disp(a).localeCompare(disp(b)); });
        html += '<div class="filter-group"><h4>' + esc(fc.label) + '</h4>' +
          '<select class="filter-select" data-facet="' + esc(fc.key) + '"><option value="">All ' + esc(fc.label.toLowerCase()) + '</option>' +
          keys.map(function (k) { return '<option value="' + esc(k) + '">' + esc(disp(k)) + '</option>'; }).join('') +
          '</select></div>';
      });
      facetsWrap.innerHTML = html;
    }
    function load(kind) {
      if (cache[kind]) { buildFacets(); buildTags(); render(); return; }
      if (facetsWrap) facetsWrap.innerHTML = '';
      resultsEl.className = 'results';
      resultsEl.innerHTML = '<div class="skel-card"></div><div class="skel-card"></div><div class="skel-card"></div><div class="skel-card"></div><div class="skel-card"></div><div class="skel-card"></div><div class="skel-card"></div><div class="skel-card"></div>';
      countEl.textContent = T('home.loading', 'Loading the library…'); emptyEl.hidden = true; moreWrap.hidden = true;
      Promise.all([window.BeneosDB.load(kind), publishedPromise]).then(function (res) {
        var content = res[0], gate = res[1] || { sets: null, hidden: {} };
        cache[kind] = normalize(kind, content).filter(function (it) {
          var k = normKey(it.key);
          if (gate.hidden && gate.hidden[k]) return false;     // release not published yet
          if (!gate.sets || !gate.sets[kind]) return true;     // gate off: fetch failed or battlemap
          return !!gate.sets[kind][k];
        });
        /* Neu ist, was am juengsten Erscheinungstag dieser Rubrik herauskam. Vorher zaehlte
           die hoechste Release-Nummer, was bei Kreaturen, Beute und Zaubern die Marke auf
           den Eintrag mit dem hoechsten Schluessel setzte statt auf den neuesten. */
        var maxDate = '';
        cache[kind].forEach(function (it) { if (it.date && it.date > maxDate) maxDate = it.date; });
        cache[kind].forEach(function (it) { it.isNew = maxDate !== '' && it.date === maxDate; });
        var tab = tabs.filter(function (t) { return t.getAttribute('data-kind') === kind; })[0];
        if (tab) { var c = $('[data-count]', tab); if (c) c.textContent = fmt(cache[kind].length); }
        if (state.kind !== kind) return;
        buildFacets(); buildTags(); render();
      }).catch(function () { resultsEl.innerHTML = ''; countEl.textContent = T('home.unavailable', 'The library is temporarily unavailable.'); });
    }
    function setKind(kind) {
      state.kind = kind; state.q = ''; state.tags = []; state.facets = {}; state.visible = PAGE; state.access = 'all';
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-kind') === kind); });
      if (searchEl) { searchEl.value = ''; searchEl.placeholder = KINDS[kind].placeholder; }
      $$('[data-ls-access] .fchip', root).forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-access') === 'all'); });
      load(kind);
    }

    tabs.forEach(function (t) { t.addEventListener('click', function () { setKind(t.getAttribute('data-kind')); }); });
    if (searchEl) { var dt; searchEl.addEventListener('input', function () { clearTimeout(dt); dt = setTimeout(function () { state.q = searchEl.value; state.visible = PAGE; render(); }, 180); }); }
    if (sortEl) sortEl.addEventListener('change', function () { state.sort = sortEl.value; render(); });
    if (facetsWrap) facetsWrap.addEventListener('change', function (e) {
      var s = e.target.closest('[data-facet]'); if (!s) return;
      state.facets[s.getAttribute('data-facet')] = s.value;
      state.visible = PAGE; render();
    });
    if (tagsWrap) tagsWrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tag]'); if (!b) return;
      var t = b.getAttribute('data-tag'), i = state.tags.indexOf(t);
      if (i > -1) state.tags.splice(i, 1); else state.tags.push(t);
      b.classList.toggle('is-active'); state.visible = PAGE;
      if (tagReset) tagReset.hidden = !state.tags.length;
      render();
    });
    if (tagReset) tagReset.addEventListener('click', function () { state.tags = []; $$('[data-tag]', tagsWrap).forEach(function (b) { b.classList.remove('is-active'); }); tagReset.hidden = true; state.visible = PAGE; render(); });
    $$('[data-ls-access] .fchip', root).forEach(function (c) { c.addEventListener('click', function () { $$('[data-ls-access] .fchip', root).forEach(function (x) { x.classList.remove('is-active'); }); c.classList.add('is-active'); state.access = c.getAttribute('data-access'); state.visible = PAGE; render(); }); });
    if (moreBtn) moreBtn.addEventListener('click', function () { state.visible += PAGE; render(); });

    /* downloads are gated: any card or download click opens the sign-in prompt */
    var auth = $('[data-ls-auth]', root);
    var pvThumb = $('[data-ls-pvthumb]', root), pvName = $('[data-ls-pvname]', root), pvSub = $('[data-ls-pvsub]', root), pvDesc = $('[data-ls-pvdesc]', root), pvTags = $('[data-ls-pvtags]', root);
    function itemByKey(key) { return (cache[state.kind] || []).filter(function (x) { return x.key === key; })[0]; }
    function openDetail(it) {
      if (!auth || !it) return;
      if (pvThumb) pvThumb.innerHTML = it.thumb ? '<img src="' + esc(it.thumb) + '" alt="' + esc(it.name) + '">' : '<div class="ph"></div>';
      if (pvName) pvName.textContent = it.name;
      if (pvSub) pvSub.textContent = it.sub || '';
      var showDesc = state.kind !== 'battlemap' && it.desc;
      if (pvDesc) { pvDesc.hidden = !showDesc; if (showDesc) pvDesc.textContent = it.desc; }
      if (pvTags) { var ts = it.tags.slice(0, 6); pvTags.hidden = !ts.length; pvTags.innerHTML = ts.map(function (t) { return '<span class="card-tag">' + esc(t) + '</span>'; }).join(''); }
      auth.hidden = false; document.body.style.overflow = 'hidden';
    }
    function closeAuth() { if (auth) { auth.hidden = true; document.body.style.overflow = ''; } }
    if (resultsEl) {
      resultsEl.addEventListener('click', function (e) { var c = e.target.closest('[data-card]'); if (c) { e.preventDefault(); openDetail(itemByKey(c.getAttribute('data-key'))); } });
      resultsEl.addEventListener('keydown', function (e) { var c = e.target.closest('[data-card]'); if ((e.key === 'Enter' || e.key === ' ') && c) { e.preventDefault(); openDetail(itemByKey(c.getAttribute('data-key'))); } });
      /* a thumbnail that 404s must never render as the browser broken-image
         glyph: swap it for the same .ph placeholder the no-thumb branch uses
         (error events do not bubble, but they are capturable) */
      resultsEl.addEventListener('error', function (e) {
        var el = e.target;
        if (el && el.tagName === 'IMG' && !el.__thumbFallback) {
          el.__thumbFallback = true;
          var ph = document.createElement('div');
          ph.className = 'ph';
          el.replaceWith(ph);
        }
      }, true);
    }
    if (auth) auth.addEventListener('error', function (e) {
      var el = e.target;
      if (el && el.tagName === 'IMG' && !el.__thumbFallback) {
        el.__thumbFallback = true;
        var ph = document.createElement('div');
        ph.className = 'ph';
        el.replaceWith(ph);
      }
    }, true);
    var authClose = $('[data-ls-authclose]', root);
    if (authClose) authClose.addEventListener('click', closeAuth);
    if (auth) auth.addEventListener('click', function (e) { if (e.target === auth) closeAuth(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && auth && !auth.hidden) closeAuth(); });

    /* lazy init when scrolled near */
    var started = false;
    /* Rubrik aus der Adresse vorwaehlen: /?explore=token#library-search
       Die drei Tueren der Startseite zeigten auf Sammlungen, die es nicht gibt
       (404). Sie fuehren jetzt hierher, und dafuer muss der Explorer den
       gewuenschten Reiter aus der Adresse lesen koennen. Ein unbekannter oder
       fehlender Wert bleibt bei battlemap, wie bisher. */
    function rubrikAusAdresse() {
      var erlaubt = { battlemap: 1, token: 1, spell: 1, item: 1 };
      var m = /[?&]explore=([a-z]+)/.exec(location.search || '');
      return (m && erlaubt[m[1]]) ? m[1] : 'battlemap';
    }
    function start() { if (started) return; started = true; setKind(rubrikAusAdresse()); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { start(); io.disconnect(); } }); }, { rootMargin: '300px' });
      io.observe(root);
    } else { start(); }
  })();

  /* library tabs + count up */
  (function () {
    var tabs = $$('.lib-tab');
    if (!tabs.length) return;
    function fmt(n) { return n.toLocaleString(document.documentElement.lang || 'en-US'); }
    function countUp(target, node) {
      var start = null, dur = 900;
      node.setAttribute('data-counted', '1');
      function tick(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        node.textContent = fmt(Math.round(target * e));
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    function activate(id) {
      tabs.forEach(function (t) { t.classList.toggle('on', t.getAttribute('data-lib') === id); });
      $$('.lib-tabpanel').forEach(function (p) { p.classList.toggle('is-hidden', p.getAttribute('data-lib') !== id); });
      var on = tabs.filter(function (t) { return t.getAttribute('data-lib') === id; })[0];
      if (on) { var cn = $('.lib-count', on); if (cn) countUp(parseInt(cn.getAttribute('data-c'), 10) || 0, cn); }
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { activate(t.getAttribute('data-lib')); }); });

    var seen = false;
    var container = tabs[0].closest('.lib-tabs') || tabs[0].parentNode;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !seen) {
            seen = true;
            var on = tabs.filter(function (t) { return t.classList.contains('on'); })[0] || tabs[0];
            var cn = $('.lib-count', on); if (cn) countUp(parseInt(cn.getAttribute('data-c'), 10) || 0, cn);
          }
        });
      }, { threshold: 0.4 });
      io.observe(container);
    }
  })();

  /* Shared live storefront stats from the App Proxy. One fetch, consumed by both
     the hero and the library tab counts. Fully dynamic: the numbers (scenes,
     creatures, spells & loot, patrons) are computed server-side from the live
     catalog + DB, so they grow with every release without a manual edit. Falls
     back to the public DB counts when the endpoint is unavailable. */
  var beneosStats = fetch('/apps/beneos/library?resource=stats', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (j) { return (j && j.result === 'OK' && j.data) ? j.data : null; })
    .catch(function () { return null; });

  /* "From the table" heading: live patron count in the <em>12 691+</em> token */
  (function () {
    var el = document.querySelector('[data-reviews-heading] em');
    if (!el) return;
    beneosStats.then(function (s) {
      if (s && s.patrons) el.textContent = s.patrons.toLocaleString(document.documentElement.lang || 'en-US') + '+';
    });
  })();

  /* library tab counts: live from the stats endpoint (fallback = public DB) */
  (function () {
    var nodes = $$('.lib-count[data-libstat]');
    if (!nodes.length) return;
    function fmt(n) { return n.toLocaleString(document.documentElement.lang || 'en-US'); }
    function setCount(kind, value) {
      if (!value) return;
      nodes.forEach(function (n) {
        if (n.getAttribute('data-libstat') !== kind) return;
        n.setAttribute('data-c', value);
        n.textContent = fmt(value);
      });
    }
    beneosStats.then(function (s) {
      if (s) {
        // "Battlemaps & sceneries" tab counts SCENES (parity with the module),
        // not catalog entries.
        setCount('battlemap', s.scenes);
        setCount('creature', s.creatures);
        setCount('spell', s.spells);
        setCount('item', s.items);
        return;
      }
      if (!window.BeneosDB) return;
      function countMaps(c) { var k = Object.keys(c), n = 0; k.forEach(function (x) { var p = (c[x] && c[x].properties) || {}; if (p.type === 'Battlemap' || p.type === 'Scenery') n++; }); return n || k.length; }
      window.BeneosDB.load('battlemap').then(function (c) { setCount('battlemap', countMaps(c)); }).catch(function () {});
      window.BeneosDB.load('token').then(function (c) { setCount('creature', Object.keys(c).length); }).catch(function () {});
      window.BeneosDB.load('spell').then(function (c) { setCount('spell', Object.keys(c).length); }).catch(function () {});
      window.BeneosDB.load('item').then(function (c) { setCount('item', Object.keys(c).length); }).catch(function () {});
    });
  })();

  /* comparison table show all */
  (function () {
    var cmp = $('#cmp'), btn = $('#cmpToggle');
    if (!cmp || !btn) return;
    btn.addEventListener('click', function () {
      cmp.classList.toggle('show-all');
      btn.innerHTML = cmp.classList.contains('show-all')
        ? T('home.show_less', 'Show less') + ' &#9652;'
        : T('home.view_all', 'View all') + ' &#9662;';
    });
  })();

  /* hero stats: live counts from the stats endpoint (fallback = public DB) */
  (function () {
    var nodes = $$('.hero [data-stat]');
    if (!nodes.length) return;
    function fmt(n) { return n.toLocaleString(document.documentElement.lang || 'en-US'); }
    function countUp(target, node) {
      var start = null, dur = 1000;
      function tick(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        node.textContent = fmt(Math.round(target * e));
        if (p < 1) requestAnimationFrame(tick); else node.textContent = fmt(target);
      }
      requestAnimationFrame(tick);
    }
    function setStat(key, value) {
      if (!value) return;
      nodes.forEach(function (n) { if (n.getAttribute('data-stat') === key) countUp(value, n); });
    }
    beneosStats.then(function (s) {
      if (s) {
        // "Battlemaps & sceneries" = live SCENE count (parity with the module).
        setStat('battlemaps', s.scenes);
        setStat('creatures', s.creatures);
        setStat('loot', s.spells_loot);
        setStat('patrons', s.patrons);
        return;
      }
      if (!window.BeneosDB) return;
      function countMaps(content) {
        var keys = Object.keys(content), n = 0;
        keys.forEach(function (k) {
          var p = (content[k] && content[k].properties) || {};
          if (p.type === 'Battlemap' || p.type === 'Scenery') n++;
        });
        return n || keys.length;
      }
      window.BeneosDB.load('battlemap').then(function (c) { setStat('battlemaps', countMaps(c)); }).catch(function () {});
      window.BeneosDB.load('token').then(function (c) { setStat('creatures', Object.keys(c).length); }).catch(function () {});
      window.BeneosDB.load('item').then(function (c) { setStat('loot', Object.keys(c).length); }).catch(function () {});
    });
  })();
})();
